import { Spacing } from '@persona-id/design-tokens';
import { FC } from 'react';
import styled from 'styled-components';

import ReactSelect from 'dashboard/components/ReactSelect';
import { Period } from 'dashboard/lib/unixTime';
import { gatherPeriodOptions } from 'dashboard/lib/utils/period';
import theme from 'design-system/theme';
import { VerificationType } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';

interface DateGranularitySelectorProps {
  value: Period;
  verificationType: VerificationType;
  handleUpdateGranularity: (type: VerificationType, period: Period) => void;
  dateRange: [Iso8601DateString | undefined, Iso8601DateString | undefined];
}

const MIN_WIDTH_SELECTOR = 128;

const StyledSelect = styled(ReactSelect<Period>)`
  color: ${({ theme }) => theme.color.text.tertiary};
`;

const VALUE_PADDING = '2px';

const singleSelectStyles = {
  control: () => ({
    minHeight: `${Spacing[6]}`,
    height: `${Spacing[6]}`,
    borderColor: `${theme.color.border.secondary}`,
    color: `${theme.color.border.secondary}`,
  }),
  container: () => ({
    minHeight: `${Spacing[6]}`,
    margin: `${Spacing[2]}`,
    minWidth: `${MIN_WIDTH_SELECTOR}px`,
  }),
  valueContainer: () => ({
    height: `${Spacing[6]}`,
    paddingBottom: VALUE_PADDING,
    color: `${theme.color.border.secondary}`,
  }),
  indicatorsContainer: () => ({
    height: `${Spacing[6]}`,
    marginRight: `${Spacing[2]}`,
  }),
};

const DateGranularitySelector: FC<DateGranularitySelectorProps> = ({
  value,
  verificationType,
  handleUpdateGranularity,
  dateRange,
}) => {
  const PERIOD_OPTIONS = gatherPeriodOptions(dateRange);
  return (
    <StyledSelect
      options={PERIOD_OPTIONS}
      value={value}
      size='sm'
      styles={singleSelectStyles}
      onChange={(newValue: Period) => {
        handleUpdateGranularity(verificationType, newValue);
      }}
      isSearchable={false}
    />
  );
};

export default DateGranularitySelector;
